// Root folder images
import AccessibilityLogo from '../../../assets/images/essential-accessability-logo.svg';
import BeginSlideshow from '../../../assets/images/begin-slideshow.svg';
import ErrorImage from '../../../assets/images/error-image.jpg';
import HeroAccent from '../../../assets/images/hero-accent.svg';
import HeroShadowsMobile from '../../../assets/images/hero-shadows-mobile.png';
import HeroShadowsOverlay from '../../../assets/images/hero-shadows-overlay.png';
import InstagramFollow from '../../../assets/images/instagram-follow.png';
import Placeholder2 from '../../../assets/images/placeholder-2.svg';
import R29Favicon from '../../../assets/images/retina_favicon_144.ico';
import R29LogoRegMark from '../../../assets/images/r29-logo-b-reg-mark.svg';
import R29Logo from '../../../assets/images/r29-logo-b.svg';
import R29LogoCondensed from '../../../assets/images/r29-logo-condensed-b.svg';
import R29LogoCondensedWhite from '../../../assets/images/r29-logo-condensed-w.svg';
import R29LogoWhite from '../../../assets/images/r29-logo-w.svg';
import R29LogoOg from '../../../assets/images/r29_oglogo_200x200.jpg';
import SeriesShadowsOverlay from '../../../assets/images/series-shadows-overlay.png';
import Squiggle from '../../../assets/images/squiggle.svg';
import SquigglyLine from '../../../assets/images/squiggly-line.svg';
import VideoIconShadow from '../../../assets/images/video-icon-shadow.png';
import R29LogoRegMarkB from '../../../assets/images/r29-logo-b-reg-mark.svg';
import ViceLogo from '../../../assets/images/vice-media-group-logo.svg';
import VideoCircleDarkArrow from '../../../assets/icons/video-circle-dark-arrow.svg';

export const StaticAssets = {
  'accessibilityLogo': AccessibilityLogo,
  'beginSlideshow': BeginSlideshow,
  'errorImage': ErrorImage,
  'heroAccent': HeroAccent,
  'heroShadowsMobile': HeroShadowsMobile,
  'heroShadowsOverlay': HeroShadowsOverlay,
  'instagramFollow': InstagramFollow,
  'placeholder2': Placeholder2,
  'r29Favicon': R29Favicon,
  'r29LogoRegMark': R29LogoRegMark,
  'r29LogoRegMarkB': R29LogoRegMarkB,
  'r29Logo': R29Logo,
  'r29LogoCondensed': R29LogoCondensed,
  'r29LogoCondensedWhite': R29LogoCondensedWhite,
  'r29LogoWhite': R29LogoWhite,
  'r29LogoOg': R29LogoOg,
  'seriesShadowOverlay': SeriesShadowsOverlay,
  'squiggle': Squiggle,
  'squigglyLine': SquigglyLine,
  'viceLogo': ViceLogo,
  'videoIconShadow': VideoIconShadow,
  'videoCircleDarkArrow': VideoCircleDarkArrow
};
